import { createSelector } from 'reselect';
import CarrierAnalysisColumns from '../../containers/CarrierAnalysisColumns';
import ReportDefinitions from '../../../../../common/config/ReportDefinitions';

export const getGeneratedOnDateTime = state => state
  .reporting.CARRIER_ANALYSIS_411.metadata.generatedOnDateTime;

export const getIsLoading =
  state => state.reporting.CARRIER_ANALYSIS_411.isLoading;

export const getData =
  ReportDefinitions.CARRIER_ANALYSIS_411.getDataFunction();

export const getColumns =
  createSelector(
    getData,
    state => state.reporting.CARRIER_ANALYSIS_411.requestParams,
    CarrierAnalysisColumns,
  );
